import * as React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import AnimalIcon from './icons/AnimalIcon';
import { Link } from 'react-router-dom';

import { useTheme } from '@mui/material/styles';


export default function AnimalNameList({animals,showLink = false,max = null,...props}) {
    const theme = useTheme();

    const list = (max) ? animals.slice(0,max) : animals;
    const remainder = (max) ? animals.length - list.length : 0;
    const remainderText = "+ " + remainder + " More";

    return (
      <List disablePadding>
        {list.map((animal) => (
          <ListItem key={animal.id} disablePadding>
            <ListItemIcon>
              <AnimalIcon />
            </ListItemIcon>
            {showLink ? (
              <Link style={{color:theme.palette.secondary.main}} to={"/animals/" + animal.id}>
                <ListItemText primary={animal.name} />
              </Link>
            ) : (
              <ListItemText primary={animal.name} />
            )}
          </ListItem>
        ))}

        {max && list.length === max && remainder > 0 &&
          <ListItem disablePadding>
            <ListItemText primary={remainderText} />
          </ListItem>
        }

      </List>
    );
}